import {IApiQuery, IPaginated} from "../core/interfaces/common";
import {useApiBase} from "./useApiBase";

export const usePaginated = <T>(url: string, queryOptions?: IApiQuery): [IPaginated<T>, boolean, () => void] => {
    return useApiBase<IPaginated<T>>(url, queryOptions);
}
